import EmptyState from '@/components/common/EmptyState';
import PageTitle from '@/components/PageTitle';
import TelegramGroupCard from '@/components/TelegramGroupCard';
import ThemeWrapper from '@/components/ThemeWrapper';
import AppLayout from '@/layouts/AppLayout';
import { Send } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface TelegramGroup {
    id: number;
    title: string;
    telegram_group_url: string | null;
}

interface Props {
    telegram_groups: TelegramGroup[];
}

const ChannelsGroupsContent: React.FC<Props> = ({ telegram_groups }) => {
    const { t } = useTranslation();

    return (
        <AppLayout>
            <PageTitle title="Canales y Grupos" />
            <div className="mx-auto max-w-7xl space-y-8">
                {/* Page Header */}
                <div className="space-y-4">
                    <h1 className="text-4xl font-bold text-gray-900 sm:text-5xl dark:text-white">
                        {t('channelsGroups.title')}
                    </h1>
                    <div className="space-y-2">
                        <p className="text-lg text-gray-700 sm:text-xl dark:text-neutral-300">
                            {t('channelsGroups.description')}
                        </p>
                        <p className="text-base font-medium text-gray-600 sm:text-lg dark:text-neutral-400">
                            {t('channelsGroups.reminder')}
                        </p>
                    </div>
                </div>

                {/* Telegram Groups Grid */}
                {telegram_groups.length === 0 ? (
                    <EmptyState
                        icon={Send}
                        title={t('channelsGroups.noGroupsTitle')}
                        description={t('channelsGroups.noGroupsDescription')}
                    />
                ) : (
                    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                        {telegram_groups.map((group) => (
                            <TelegramGroupCard key={group.id} group={group} />
                        ))}
                    </div>
                )}
            </div>
        </AppLayout>
    );
};

const ChannelsGroups: React.FC<Props> = ({ telegram_groups }) => (
    <ThemeWrapper>
        <ChannelsGroupsContent telegram_groups={telegram_groups} />
    </ThemeWrapper>
);

export default ChannelsGroups;
